import { render, staticRenderFns } from "./ArticlesOverTime.vue?vue&type=template&id=56c8c6d1&scoped=true&"
import script from "./ArticlesOverTime.vue?vue&type=script&lang=js&"
export * from "./ArticlesOverTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c8c6d1",
  null
  
)

export default component.exports